import React from 'react'
import './runnerUpHeader.css'
import SelectField from "../../library/components/Select";
import { Validators } from "../../library/utilities/Validator";
export function RunnerUpHeader({ label, search, show, stateList, states, handleChange, getError }) {

  return (
    <>
      <div className='head'>
        <h5>{label}</h5>
        {search}
      </div>
    </>
  )
}
